function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { StateStatus } from '@guryou/redux';
const PrivateRoute = ({
  component: Component,
  saveRegion = false,
  ...rest
}) => {
  const el = new URLSearchParams(window.location.search).get('el');
  const pw = new URLSearchParams(window.location.search).get('pw');
  const auth = useSelector(state => state.auth);
  let url = '/login';
  if (el && pw) {
    url = `/login?el=${decodeURIComponent(el)}&pw=${decodeURIComponent(pw)}`;
  }
  if (!auth || auth?.data === null || auth?.staus < StateStatus.LOADED || auth.data.exp * 1000 < +new Date()) {
    if (auth?.data && auth?.data?.user === null) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: url
      });
    }
    return /*#__PURE__*/React.createElement(Redirect, {
      to: url
    });
  }
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => /*#__PURE__*/React.createElement(Component, props)
  }));
};
export { PrivateRoute };